<app-header
  [collection_id]="collectionId"
  [operationMode]="operationMode"
  [subRoute]="step"
  (settingsRouteActivate)="settingsRouteActivate()"
  [inputPlaceholder]="'Enter Test Title'"
></app-header>
<h1 class="sr-only">Create/Edit Assessment</h1>
<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-lg-8 col-md-8 mx-auto mt-4 align-center">
      <app-tabs
        [tabIndex]="tabIndex"
        (tabClick)="tabClick($event)"
        [showSteps]="true"
      >
        <app-tab name="Content"></app-tab>
        <app-tab
          *ngIf="itemsList.references != undefined"
          name="Settings"
        ></app-tab>
        <app-tab
          *ngIf="itemsList.references === undefined"
          name="Settings"
          [disabled]="true"
        ></app-tab>
      </app-tabs>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-1 col-lg-1"></div>
    <div
      *ngIf="
        step === 'step1' && itemsList.references != undefined;
        else zero_state
      "
      class="col-md-10 col-lg-10 ml-5"
    >
      <div class="row">
        <div class="col-md-12 col-lg-12 page-title">
          <header class="workspace_header">
            <span><i class="m-right-9 fa"></i>Your Test</span>
          </header>
        </div>
      </div>
      <div class="row header-row buttonsPanel">
        <div class="col-md-6 col-lg-6 mt-2 ml-4 addQuestionEditAlign">
          <app-button
            buttonText="+ Add Question"
            [purpose]="_buttonPurpose.Secondary"
            (click)="addEditQuestions()"
          ></app-button>
          <div id="questionTypeContainer">
            <app-question-type-dropdown
              [showQuestionTypes]="showQuestionTypes"
              (emitValueOfDropdown)="updateChangeValueOfDropdown($event)"
              (emitItemInfo)="passValueToSource($event)"
              [menuWidth]="100"
            ></app-question-type-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-lg-3 previewButtonStyle">
          <app-button
            [disabled]="itemsList.references.length == 0"
            buttonText="Preview test questions"
            [purpose]="_buttonPurpose.Secondary"
            (click)="previewSourceQuestions()"
          ></app-button>
        </div>
      </div>

      <div
        class="row h-20 justify-content-center font-color"
        class="row question-list-header"
      >
        <div class="col-md-1 col-lg-1 text-left">
          <div class="form-group text-right mt-3"></div>
        </div>
        <div class="col-md-1 col-lg-1">
          <div class="form-group text-left">
            <div class="edit-selectall">
              <app-checkbox
                id="selectAll"
                [checked]="selectAll.selected"
                #selectAllEdit
                (change)="selectAllQuestions($event)"
              ></app-checkbox>
            </div>
          </div>
        </div>
        <div class="col-md-5 col-lg-5 text-left">
          <div
            class="form-group"
            sortColumn
            [sortKey]="'title'"
            [data]="itemsList.references"
            (sortEvent)="sortOnlyUnpinned($event)"
          >
            <label class="mt-3 cursor-style">Question</label>
            <div class="icon-container-title">
              <i
                class="dpg-icon dpg-icon-system-sort-white cursor-style dpg-icon-edit question"
              ></i>
            </div>
          </div>
        </div>
        <div
          class="col-md-3 col-lg-3 text-left"
          style="padding: 0 !important; max-width: 225px"
        >
          <div
            class="form-group"
            sortColumn
            [sortKey]="'typeDesc'"
            [data]="itemsList.references"
            (sortEvent)="sortOnlyUnpinned($event)"
          >
            <label class="mt-3 cursor-style">Type</label>
            <div class="icon-container-title">
              <i
                class="dpg-icon dpg-icon-system-sort-white cursor-style dpg-icon-edit type"
              ></i>
            </div>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 text-left point-cnt">
          <div class="form-group">
            <label class="cursor-style pb-5 mb-sm-0" style="margin-top: 7px"
              >Points</label
            >
          </div>
        </div>
        <div class="col-md-1 col-lg-1 text-right"></div>
      </div>
      <div
        [style.height.px]="editCompHeight"
        class="edit-list"
      >
        <!-- {{itemsList.references|json}}-->
        <ng-container
          *ngFor="let question of itemsList.references; let quesInd = index"
        >
          <div
            *ngIf="!question.isDeleted"
            [ngClass]="
              question.refType == 'multipart' ? 'section-break-cont' : ''
            "
          >
            <div
              class="row1 h-20"
              [ngClass]="question.refType == 'scalar' ? 'border-bottom' : ''"
            >
              <div class="col-md-1 col-lg-1 text-left">
                <div class="form-group text-right mt-3">
                  <span
                    *ngIf="!question.pinned"
                    class="handles"
                    style="position: relative; top: 9px; margin-right: 1px"
                  >
                    <i class="dpg-icon dpg-icon-movingtile"></i>
                  </span>
                  <span
                    *ngIf="question.pinned"
                    class="handles"
                    style="position: relative; top: 9px; margin-right: 10px"
                  >
                    <i class="fa fa-thumb-tack" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="col-md-1 col-lg-1 text-left">
                <div style="position: relative; top: 10px">
                  <app-checkbox
                    id="editQuestions{{ quesInd }}"
                    #editedQuestions
                    [checked]="question.selected"
                    (change)="OnCheckboxSelect(question, $event)"
                  >
                  </app-checkbox>
                </div>
              </div>
              <div class="col-md-5 col-lg-5">
                <div class="row">
                  <div
                    class="col-md-10 col-lg-10 form-group mt-4 question-title"
                  >
                    <label
                      title="{{ question.title }}"
                      [innerHtml]="
                        question.title | truncate : [50, '...'] | linebreak : 36
                      "
                      (click)="questionLinked(question, quesInd)"
                    ></label>
                  </div>
                  <div
                    class="col-md-1 col-lg-1 mt-4"
                    style="width: 19px; padding: 0; margin-left: -15px"
                  >
                    <a
                      *ngIf="question.algo"
                      class="qpickerIcons algorithmicBig"
                      [ngStyle]="{
                        background:
                          'url(' +
                          algoImgUrl +
                          ') no-repeat scroll left transparent'
                      }"
                      alt="Algorithmic"
                      title="Algorithmic"
                    >
                    </a>
                  </div>
                  <div
                    class="col-md-1 col-lg-1 mt-4"
                    style="width: 19px; padding: 0"
                  >
                    <span class="editQuestionsHandle">
                      <i
                        *ngIf="
                          question.userEdited && question.refType == 'scalar'
                        "
                        id="droppedKebabId{{ question.index }}"
                        class="dpg-icon dpg-icon-more-practice"
                        title="My Edited Question"
                      ></i>
                      <i
                        *ngIf="
                          question.edited == 1 &&
                          question.refType == 'multipart'
                        "
                        id="droppedKebabId{{ question.index }}"
                        class="dpg-icon dpg-icon-more-practice"
                        title="My Edited Question"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col-md-3 col-lg-3 text-left"
                style="padding-left: 8px"
              >
                <div class="form-group mt-3">
                  <label
                    class="assesment-position"
                    title="{{ question.typeDesc }}"
                    [innerHtml]="question.typeDesc"
                  ></label>
                </div>
              </div>
              <div class="col-md-1 col-lg-1 text-left pointWidth">
                <div
                  class="ahe-ui form-group mt-3"
                  *ngIf="!isSectionBreak(question.refType)"
                >
                  <app-input
                    id="points_{{ quesInd }}"
                    [(ngModel)]="question.points"
                    (ngModelChange)="updateModel(question)"
                    (focusout)="validatePoints($event)"
                    maxlength="7"
                  ></app-input>
                </div>
              </div>
              <div class="col-md-1 col-lg-1 text-left">
                <div
                  class="form-group mt-3"
                  (click)="setKebabIndex(quesInd)"
                  *ngIf="!isSectionBreak(question.refType)"
                >
                  <kebab-component
                    [question-source]="true"
                    [kebabMenuItems]="kebabMenu"
                    [show_kebab]="quesInd === kebabIndex"
                    [last_kebab]="
                      kebabIndex === arrayIndex - 1 && kebabIndex > 2
                    "
                    [collection]="question"
                    [checked-questions]="sortedQuestionsList()"
                    (pinUnpinQuestion)="pinUnpinQuestion($event)"
                    [disableDelete]="true"
                    (softDelete)="softSourceDelete($event)"
                    (emitQuestionUpdate)="sourceQuestionUpdate($event)"
                    (emitItemInfo)="kebabPreview($event)"
                  ></kebab-component>
                </div>
                <div
                  class="form-group mt-3"
                  (click)="setKebabIndex(quesInd)"
                  *ngIf="isSectionBreak(question.refType)"
                >
                  <kebab-component
                    [question-source]="true"
                    [kebabMenuItems]="sectionBreakKebabMenu"
                    [show_kebab]="quesInd === kebabIndex"
                    [last_kebab]="
                      kebabIndex === arrayIndex - 1 && kebabIndex > 2
                    "
                    [collection]="question"
                    [checked-questions]="sortedQuestionsList()"
                    (pinUnpinQuestion)="pinUnpinQuestion($event)"
                    [disableDelete]="true"
                    (softDelete)="softSourceDelete($event)"
                    (emitQuestionUpdate)="sourceQuestionUpdate($event)"
                    (emitItemInfo)="kebabPreview($event)"
                  ></kebab-component>
                </div>
              </div>
            </div>
            <!-- section break questions start here-->
            <div *ngIf="isSectionBreak(question.refType)">
              <ng-container
                *ngFor="let partQues of question.parts; let j = index"
              >
                <div *ngIf="!partQues.isDeleted" class="row1 h-20">
                  <div class="col-md-1 col-lg-1 text-left">
                    <div class="form-group text-right mt-3"></div>
                  </div>
                  <div class="col-md-1 col-lg-1 text-left">
                    <div style="position: relative; top: 10px">
                      <app-checkbox
                        id="editQuestions{{ quesInd }}"
                        #editedQuestions
                        [checked]="partQues.selected"
                        (change)="OnCheckboxSelect(partQues, $event)"
                      >
                      </app-checkbox>
                    </div>
                  </div>
                  <div
                    class="col-md-5 col-lg-5"
                    [ngClass]="[
                      decideBottomBorder(question, j),
                      decideTopBorder(question, j),
                      decideTopLeftCorner(j),
                      decideBottomLeftCorner(question, j),
                      setBackground(),
                      borderLeft()
                    ]"
                  >
                    <div class="row">
                      <div
                        class="col-md-10 col-lg-10 form-group mt-4 question-title"
                      >
                        <label
                          title="{{ partQues.title }}"
                          [innerHtml]="
                            partQues.title
                              | truncate : [50, '...']
                              | linebreak : 36
                          "
                          (click)="questionLinked(partQues, quesInd)"
                        ></label>
                      </div>
                      <div
                        class="col-md-1 col-lg-1 mt-4"
                        style="width: 19px; padding: 0; margin-left: -15px"
                      >
                        <a
                          *ngIf="partQues.algo"
                          class="qpickerIcons algorithmicBig"
                          [ngStyle]="{
                            background:
                              'url(' +
                              algoImgUrl +
                              ') no-repeat scroll left transparent'
                          }"
                          alt="Algorithmic"
                          title="Algorithmic"
                        >
                        </a>
                      </div>
                      <div
                        class="col-md-1 col-lg-1 mt-4"
                        style="width: 19px; padding: 0"
                      >
                        <span class="editQuestionsHandle">
                          <i
                            *ngIf="partQues.edited == 1"
                            id="droppedKebabId{{ question.index }}"
                            class="dpg-icon dpg-icon-more-practice"
                            title="My Edited Question"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-3 col-lg-3 text-left"
                    [ngClass]="[
                      decideBottomBorder(question, j),
                      decideTopBorder(question, j),
                      setBackground()
                    ]"
                    style="padding-left: 8px"
                  >
                    <div class="form-group mt-3">
                      <label
                        class="assesment-position"
                        title="{{ partQues.typeDesc }}"
                        [innerHtml]="partQues.typeDesc"
                      ></label>
                    </div>
                  </div>
                  <div
                    class="col-md-1 col-lg-1 text-left pointWidth"
                    style="z-index: 10"
                    [ngClass]="[
                      decideBottomBorder(question, j),
                      decideTopBorder(question, j),
                      setBackground()
                    ]"
                  >
                    <div class="ahe-ui form-group mt-3">
                      <app-input
                        id="question-points{{ j }}"
                        [(ngModel)]="partQues.points"
                        (ngModelChange)="updateModel($event)"
                        type="text"
                        (focusout)="validatePoints($event)"
                        maxlength="7"
                      ></app-input>
                    </div>
                  </div>
                  <div
                    style="padding: 14px 0px 0px 31px"
                    class="col-md-1 col-lg-1 text-left"
                    [ngClass]="[
                      decideBottomBorder(question, j),
                      decideTopBorder(question, j),
                      decideTopRightCorner(j),
                      decideBottomRightCorner(question, j),
                      setBackground(),
                      borderRight()
                    ]"
                  >
                    <div
                      id="{{ indexCal(quesInd, j) }}"
                      (click)="setKebabIndex(indexCal(quesInd, j))"
                    >
                      <kebab-component
                        [question-source]="true"
                        (softDelete)="softSourceDelete($event)"
                        [collection]="partQues"
                        [selectedQuestion]="question"
                        [show_kebab]="indexCal(quesInd, j) === kebabIndex"
                        [disableDelete]="true"
                        [kebabMenuItems]="partQuestionKebabMenu"
                        [last_kebab]="
                          kebabIndex === arrayIndex - 1 && kebabIndex > 2
                        "
                        (emitQuestionUpdate)="sourceQuestionUpdate($event)"
                        (emitItemInfo)="kebabPreview($event)"
                      ></kebab-component>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- section break questions end here-->
          </div>
        </ng-container>
      </div>
    </div>

    <ng-template #zero_state>
      <div *ngIf="step === 'step1'" class="container-fluid">
        <div class="row no-margin zero-state-container" [style.height.px]="zeroStateCompHeight">
          <div class="col-12 col-lg-8 col-md-8 mx-auto mt-4 align-center zero-state">
            <div style="margin-top: 80px">
              <strong class="empty-test-message">Your test is empty.</strong>
              <div style="margin-top: 30px">
                <app-button
                  buttonText="+ Add question"
                  [purpose]="_buttonPurpose.Primary"
                  (click)="addZeroQuestions()"
                ></app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div class="col-md-12 col-lg-12">
  <print-preference
    *ngIf="step === 'step2'"
    [collection_id]="collectionId"
  ></print-preference>
</div>
<div
  class="col-md-12 col-lg-12 col-xl-12 mt-5 text-center footer-{{
    step
  }} footer-pad"
>
  <app-footer
    [collection_id]="collectionId"
    [operationMode]="operationMode"
    [currentStep]="step"
  ></app-footer>
</div>

<modal-component
  *ngIf="modalShow"
  [message]="alertMessage"
  [size]="size"
  [modal-opt-option]="showModal"
  (modalOptOptionEvent)="modalOptOut($event)"
  (modalOk)="modalOkJob()"
  (modalCancel)="modalCancelJob()"
>
</modal-component>

<preview-modal-component
  *ngIf="closeModalPopUp"
  [header]="Preview"
  [type]="type"
  [preview-data]="previewUrl"
  [question-index]="qIndex"
  (addQuestionClicked)="addQuestionClicked($event)"
  (closeModal)="closeModal($event)"
></preview-modal-component>

<preview-modal-component
  *ngIf="isPreviewTestQuestions"
  [sourceLocationInfo]="'RightPanel'"
  [preview-data]="questionPreviewList"
  [header]="previewHeaderText"
  [question-index]="qIndex"
  (addQuestionClicked)="addQuestionClicked($event)"
  (closeModal)="closeModal($event)"
></preview-modal-component>
<!-- Section Break Question Delete From Right Panel---->
<div
  *ngIf="showSectionBreakQuestionDeleteModal"
  class="ahe-ui-alert-modal"
  id="sbDeleteModal"
  role="dialog"
  tabindex="-1"
>
  <div class="modal-overlay" id="previewModalOverlay1111">
    <div class="modal-container-new">
      <div class="modal-dialog-copy">
        <div class="modal-content">
          <div class="modal-header-new">
            {{ DeleteModalHeader }}
            <button
              aria-label="close dialog"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closeSectionBreakModal(true)"
            >
              <span class="ahe-icon ahe-icon-close-white"></span>
            </button>
          </div>
          <div class="modal-body-new">
            <div class="question-body">
              <div class="div-cont">
                <div class="child-cont-1">
                  <i class="dpg-icon-system-alert-warning"></i>
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg1'">
                  All questions in the section break will be deleted.<br /><br />
                  Delete section break?
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg2'">
                  This section break will be deleted, because there are no
                  questions left. <br /><br />Delete Question?
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer-new">
            <app-button
              class="align-left"
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              data-dismiss="modal"
              (click)="closeSectionBreakModal()"
              style="padding-left: 24px"
            >
            </app-button>
            <app-button
              *ngIf="secBreakRemove"
              buttonText="Yes"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="confirmSectionBreakRemove()"
              style="padding-left: 3px"
            >
            </app-button>
            <app-button
              *ngIf="partQuestionRemove"
              buttonText="Yes"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="confirmPartQuestionRemove()"
              style="padding-left: 3px"
            >
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
